<template>
  <div class="modal-sidebar-wrapper">
    <div class="modal-sidebar">
      <div class="modal-sidebar-header">
        <slot name="preview-link"></slot>
        <slot name="editor-title">
          <p>{{ $t('module_editor.module_editor') }}</p>
        </slot>
        <span title="Close Module" class="close-modal" @click="$emit('closeModuleSidebar')">
          <i class="icon icon-close"></i>
        </span>

      </div>

      <div class="modal-sidebar-body">
        <div v-if="parentSidebarTab === 'content'">
          <p class="modal-sidebar-header-text">{{ $t('module_editor.content') }}</p>
          <ul class="content-blocks">
            <draggable :list="partsList" :options="{ group: { name: 'omega', pull: 'clone', put: false }, sort: false }" :clone="cloneNewPart">
              <li v-for="part in partsList" class="part-list-button" :key="part.id" @click="addPartToDocument(part)">
                <span>
                  <i class="icon" :class="part.icon"></i>
                  {{ part.title }}
                </span>
                <div class="document-drag-zone">{{ $t('module_editor.drop_content_here') }}</div>
              </li>
            </draggable>
          </ul>
        </div>
      </div>

      <div class="modal-sidebar-footer">
        <span class="actions">
          <a class="button is-primary is-large" @click="$emit('save')">{{ $t('module_editor.save_changes') }}</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import DocumentSidebar from 'mixins/document-sidebar';

  export default {
    props: ['cover', 'document', 'documentLoaded', 'showModuleSidebar'],
    mixins: [DocumentSidebar],
    data() {
      return {
        parentSidebarTab: 'content',
        partsList: require('settings/documentPartsList')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";
  @import "resources/assets/sass/partial/document-sidebar";
</style>



// WEBPACK FOOTER //
// module-editor-sidebar.vue?381515f5